/**
 * The face a rules engine shows the table shell.
 *
 * One sentence draws the line: the engine speaks seat numbers, never
 * identities. Nick, avatar, chat, blocking, timers and storage belong to the
 * shell; rules, turn order, views and results belong to the engine.
 */
/**
 * The games, once. Everything keyed by game is a `Record<GameFamily, ...>`, so a game added here
 * does not compile until it has an engine, its house rules and a default goal (review 0027 Ö2).
 */
export const GAME_FAMILIES = [
    "batak",
    "spades",
    "tarneeb",
    "baloot",
    "hearts",
    "king",
    "pisti",
];
/**
 * Games played over a fixed number of hands and never to a score (King): the lengths on offer,
 * the first one the default. The shell offers these instead of a goal.
 */
export const MATCH_LENGTHS = {
    king: [20, 12],
};
export const TEMPOS = ["relaxed", "normal", "fast"];
export const BOT_LEVELS = ["medium", "expert"];
/** A move the engine refused; the shell turns it into a client error. */
export class GameRuleError extends Error {
    code;
    constructor(code) {
        super(code);
        this.name = "GameRuleError";
        this.code = code;
    }
}
//# sourceMappingURL=contract.js.map